import React from 'react'
import PropTypes from 'prop-types'

import DayPickerInput from 'react-day-picker/DayPickerInput'

import noop from 'lodash/noop'

import './style.scss'
import 'react-day-picker/lib/style.css'


const _renderErrors = (errors) => {
  const _renderError = (error, idx) => <li key={idx}>{error}</li>
  const hasErrors =  errors.length > 0

  return hasErrors ? (
    <ul className="errors-list">
      {errors.map(_renderError)}
    </ul>
  ) : null
}


export default function DateInput(props) {

  const _onDateChanged = (dateObject) => {
    let date = ''
    try {
      date = dateObject.format(props.format)
    } catch(e) {}

    // so we simulate normal operation with evt.target
    // this will avoid to replicate this validation and date parsing every time
    // we want to have date as string.
    // at the time we don't need the Date Object received here, but
    // just in case, we can access it on the same callback
    props.onChange({
      date: dateObject,
      target: {
        name: props.name,
        value: date
      }
    })
  }


  const Label = !!props.label ? ( <label>{props.label}</label> ) : null
  const errorClass = props.errors.length ? 'has-error' : ''
  return (
    <div className={`DateInput ${errorClass}`}>
      {Label}
      <div className={`DateInput__wrapper ${errorClass}`}>
        <div className="DateInput__wrapper__icon">
          <i className="material-icons">date_range</i>
        </div>
        <DayPickerInput
          format={props.format}
          name={props.name}
          onDayChange={_onDateChanged}
          placeholder={props.format}
          type="text"
          value={props.value}
        />
      </div>
      {_renderErrors(props.errors)}
    </div>
  )
}

DateInput.defaultProps = {
  errors: [],
  format: 'YYYY-MM-DD',
  name: '',
  onChange: noop,
  value: '',
}

DateInput.propTypes = {
  errors: PropTypes.array,
  format: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/components/DateInput/index.js